import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><defs><style type=\"text/css\"></style></defs><path d=\"M800.9 905.7H226.7c-38.5 0-69.8-32.3-69.8-71.9V410.9c0-11 9-20 20-20s20 9 20 20v422.9c0 17.6 13.4 31.9 29.8 31.9h574.2c16.5 0 29.8-14.3 29.8-31.9V410.9c0-11 9-20 20-20s20 9 20 20v422.9c0 39.6-31.3 71.9-69.8 71.9z\" p-id=\"1345\" /><path d=\"M602.7 603.1c5.4 0 10 4.6 10 10v253.3H417.1V613.1c0-5.4 4.6-10 10-10h175.6m0-40H427.1c-27.5 0-50 22.5-50 50v293.3h270.6c2.8 0 5-2.3 5-5V613.1c0-27.5-22.5-50-50-50zM68.1 485.1l-0.9-1.2c-6.8-8.7-5.2-21.3 3.5-28.1l429.1-334.2c8.7-6.8 21.3-5.2 28.1 3.5l0.9 1.2c6.8 8.7 5.2 21.3-3.5 28.1L96.2 488.6c-8.7 6.8-21.4 5.2-28.1-3.5z\" p-id=\"1346\" /><path d=\"M955.9 485.1l0.9-1.2c6.8-8.7 5.2-21.3-3.5-28.1L524.2 121.7c-8.7-6.8-21.3-5.2-28.1 3.5l-0.9 1.2c-6.8 8.7-5.2 21.3 3.5 28.1l429.1 334.2c8.7 6.7 21.4 5.1 28.1-3.6z\" p-id=\"1347\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 45